import validate from "/opt/build/repo/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@22.10.2_eslint@8.57.1_ioredis@5.4.1_ma_0c549da0b51d0dd9114fd09ade062f5e/node_modules/nuxt/dist/pages/runtime/validate.js";
import netlify_45redirects_45global from "/opt/build/repo/middleware/netlify-redirects.global.js";
import trailing_45slash_45global from "/opt/build/repo/middleware/trailing-slash.global.js";
import manifest_45route_45rule from "/opt/build/repo/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@22.10.2_eslint@8.57.1_ioredis@5.4.1_ma_0c549da0b51d0dd9114fd09ade062f5e/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  netlify_45redirects_45global,
  trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}